import {useState} from "react";

// Tab state that survives a page refresh: seeded from (and written back to)
// localStorage under the given key, so a palette reopens on the same list.
export function usePaletteTab(storageKey: string, defaultTab: string): [string, (tab: string) => void] {
    const [tab, setTabState] = useState<string>(() => localStorage.getItem(storageKey) ?? defaultTab);
    const setTab = (next: string) => {
        localStorage.setItem(storageKey, next);
        setTabState(next);
    };
    return [tab, setTab];
}

// Tab button for switching which list a palette shows — mirrors the Tech Tree
// Assets palette (AssetTabButton). Buttons share the row width equally.
function PaletteTabButton(props: { label: string; current: string; onClick(tab: string): void }) {
    const selected = props.label === props.current;
    return (
        <button
            className={`layout horizontal center stretch bar-state ${selected ? 'bar-state-active' : 'bar-state-inactive'}`}
            style={{flexGrow: 1}}
            onClick={() => props.onClick(props.label)}>
            {props.label}
        </button>
    );
}

export default PaletteTabButton;
